import React from 'react';
import {Modal, ModalTitleProps} from '@mantine/core';

export const EtroModalTitle: React.FC<ModalTitleProps> = props => {
  return <Modal.Title {...props} />;
};
